var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _circle, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _rect5, _rect6, _polygon3, _polygon4, _rect7, _rect8, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 509.04617,
    height: 507.58297,
    viewBox: "0 0 509.04617 507.58297",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M849.64684,650.42149c-6.29981,13.08-17.90967,22.81-30.08008,30.72a189.91394,189.91394,0,0,1-42.65967,20.65c-2.06006.71-4.14014,1.37-6.23,2H686.16686c-.58985-.64-1.14991-1.31-1.67969-2-5.66016-7.25-8.72022-16.54-7.61035-25.64,1.43017-11.69,10.31006-22.43,21.81006-24.91,11.51025-2.49,24.62988,4.38,28.12988,15.63,1.92041-21.68,4.14013-44.26,15.66015-62.72,10.44-16.71,28.51026-28.67,48.08985-30.81a60.558,60.558,0,0,1,33.48,6.13c.95019.48,1.89014.98,2.81006,1.5a56.01477,56.01477,0,0,1,16.14013,13.77C855.20689,610.20146,858.19713,632.67149,849.64684,650.42149Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M826.23717,582.34147a317.0801,317.0801,0,0,0-90.56006,119.45c-.29.66-.58008,1.33-.86035,2h-3.98c.28027-.67.56006-1.34.8501-2,3.85009-9,8.10009-17.84,12.77-26.45a321.86119,321.86119,0,0,1,34.91016-51.66,316.96987,316.96987,0,0,1,44.25977-43.95,1.92937,1.92937,0,0,1,.41992-.26,2.03244,2.03244,0,0,1,2.81006,1.5A1.47782,1.47782,0,0,1,826.23717,582.34147Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.69113,489.79547a9.49736,9.49736,0,0,0-1.2033-14.51328l-4.79626-31.61935-19.70117,6.20064,10.793,28.20962a9.54884,9.54884,0,0,0,14.90777,11.72237Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.39552,474.91987l-12.153-56.75662a32.50067,32.50067,0,0,1,9.28145-30.39262c15.55594-14.99054,35.549-33.88518,42.455-38.77257a35.60558,35.60558,0,0,1,22.27647-6.57547l.1667.01833,10.454,9.87947-22.773,37.48872-34.57167,21.66118,3.84723,55.62884Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#75aff7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.47998,
    y: 201.58297,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134.47998,
    y: 288.58297,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M509.95689,702.79149a2.00014,2.00014,0,0,1-1.99218-1.82325l-25.4961-299a2,2,0,1,1,3.98438-.35351l23.4751,276.25146L532.736,401.61961a2.00007,2.00007,0,1,1,3.98535.34375l-24.77173,299a2.00031,2.00031,0,0,1-1.99023,1.82813Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 221.71456,
    cy: 108.00686,
    r: 26.2388,
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "143.516 494.591 131.038 490.614 140.44 440.589 158.858 446.459 143.516 494.591",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M488.29845,701.86815,448.12731,689.064l.33178-1.04346a15.829,15.829,0,0,1,19.86377-10.26172l25.10889,8.00342Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.305 494.332 221.208 494.332 214.975 443.814 234.305 443.814 234.305 494.332",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M541.92613,702.20262H582.089V687.29881H556.73522a14.826,14.826,0,0,0-14.80909,14.80908Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M579.39886,674.14679l-4.42041-.65966c-13.407-1.99756-14.20972-2.11719-16.33814-3.05176-1.08691-.47754-1.16333-7.69336-.51074-48.25586.47876-29.77441,1.075-66.82959-.08252-86.72266a3.49939,3.49939,0,0,0-6.70312-1.18066c-9.97559,23.03711-26.71216,74.59033-37.78711,108.7041-3.8523,11.8667-6.895,21.23926-8.82007,26.85742a4.52374,4.52374,0,0,1-5.35352,2.898c-9.114-2.27832-8.50464-3.24707-21.48559-6.60449a4.48877,4.48877,0,0,1-3.28174-5.28174c2.3479-11.07226,45.31445-190.59961,48.60327-207.66553a4.50168,4.50168,0,0,1,5.30518-3.57177c9.67382,1.94922,15.55908,4.01709,25.11889,6.0166,10.31543,2.15771,20.98218,4.38916,31.38648,6.47168h0a4.46279,4.46279,0,0,1,2.61914,1.60547c2.57446,3.25146,6.39184,5.07666,10.43359,7.00879,2.72486,1.30273-3.44971,1.18533-1.07666,3.064,9.60987,7.60739-4.20947,162.08759-12.55957,196.97754a4.51512,4.51512,0,0,1-5.04736,3.39062Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M578.3752,327.1751c-1.53189-6.5001,6.21217-20.48653,4.68028-26.98663-1.03742-4.402-11.38856-1.4096-13.8042-5.233s-6.46185-6.92092-10.98412-6.97167c-5.198-.05833-10.31284,3.79748-15.23684,2.131-4.97869-1.685-6.57-8.50289-4.36887-13.27591s6.94276-7.81448,11.62747-10.19775c7.97753-4.05846,17.26629-7.02216,25.80456-4.337,5.16141,1.62317,9.477,5.14031,13.65329,8.58027,3.80691,3.1357,7.67786,6.34249,10.3391,10.495,5.21345,8.13482,4.8989,19.09552.44362,27.66907s-12.57337,14.86516-21.51861,18.51726",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M513.947,478.44172c2.832-4.731,7.1316-26.89746,12.43384-64.10352,3.60987-25.39893,6.75513-51.206,8.31568-64.38867a6.33875,6.33875,0,0,1,3.55957-5.00147q1.519-.73315,3.02-1.38769c12.92309-5.6211,26.01977-7.4834,38.92407-5.53613a70.61872,70.61872,0,0,1,34.91894,15.91113l.11743.11084.03028.1582c.05615.293,5.47583,29.498-5.625,49.22949-10.94824,19.46875-11.07593,71.02637-11.07593,71.54493v.66259l-.63745-.18164c-17.032-4.8667-82.825,3.64746-83.48779,3.73438l-1.02442.13379Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#75aff7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.47998,
    y: 214.58297,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 212.47998,
    y: 301.58297,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M587.95689,703.79149a2.00014,2.00014,0,0,1-1.99218-1.82325l-25.4961-287a2,2,0,1,1,3.98438-.35351l23.4751,264.25146L610.736,414.61961a2.00007,2.00007,0,0,1,3.98535.34375l-24.77173,287a2.00031,2.00031,0,0,1-1.99023,1.82813Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M571.48986,499.05847a9.49736,9.49736,0,0,1,8.89632-11.52991l21.20756-23.938,13.16967,15.9105-24.389,17.81707a9.54884,9.54884,0,0,1-18.88457,1.74031Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M583.83758,482.39728l33.457-44.60937-17.25244-36.96973,1.25268-43.8457,14.14429-2.61328.1499.07519A35.60551,35.60551,0,0,1,630.717,372.0589c3.14185,7.85547,9.65894,34.58106,14.57251,55.61817a32.50066,32.50066,0,0,1-8.7229,30.55761l-41.04248,41.043Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#75aff7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M443.5874,691.38672l45.77295,11.02051a3.9224,3.9224,0,0,0,4.55469-2.126l39.31982-104.542a3.221,3.221,0,0,0,.00342-2.5459,3.6438,3.6438,0,0,0-2.09473-1.96094L496.729,578.08984a4.13866,4.13866,0,0,0-3.37451.18653,3.511,3.511,0,0,0-1.84033,2.25195l-.001.00488-24.29,92.13868-.36084.02246c-.13964.00878-14.06445.95605-20.32617,8.47265A13.29147,13.29147,0,0,0,443.5874,691.38672Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M841.47691,702.79149a.99651.99651,0,0,1-1,1h-494a1,1,0,0,1,0-2h494A.9965.9965,0,0,1,841.47691,702.79149Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 496.49761,
    y: 615.00452,
    width: 2.00036,
    height: 41.96505,
    transform: "translate(-532.82219 867.53261) rotate(-83.95484)",
    fill: "#b3b3b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 488.47978,
    y: 639.31409,
    width: 2.00037,
    height: 36.8254,
    transform: "translate(-656.64704 638.02494) rotate(-65.77563)",
    fill: "#b3b3b3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.384 426.985 137.801 413.875 138.622 412.051 178.205 425.161 177.384 426.985",
    fill: "#b3b3b3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.384 417.985 141.801 398.875 142.622 397.051 182.205 416.161 181.384 417.985",
    fill: "#b3b3b3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 482.22839,
    y: 659.10206,
    width: 1.99972,
    height: 37.53461,
    transform: "translate(-691.52954 408.79356) rotate(-49.49475)",
    fill: "#b3b3b3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 465.32425,
    y: 672.1761,
    width: 1.99991,
    height: 27.74641,
    transform: "translate(-587.18635 57.62524) rotate(-24.39334)",
    fill: "#b3b3b3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M729.81676,674.19562V218.39167c0-6.155.11713-12.32315,0-18.4774-.00512-.26907,0-.53868,0-.80782,0-3.86072-6-3.86711-6,0v455.804c0,6.155-.11713,12.32315,0,18.4774.00512.26907,0,.53868,0,.80782,0,3.86072,6,3.86711,6,0Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M763,326.5H691a6.50753,6.50753,0,0,1-6.5-6.5V232.5A6.50753,6.50753,0,0,1,691,226h72a6.50753,6.50753,0,0,1,6.5,6.5V320A6.50753,6.50753,0,0,1,763,326.5Z",
    transform: "translate(-345.47691 -196.20851)",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporel);
export default __webpack_public_path__ + "static/media/Corporel.a0eba0a822fc0bc24d0b313fc2a63f98.svg";
export { ForwardRef as ReactComponent };